import axios from "config/axios/base";
import qs from "qs";

export const postPhysicianAppointment = ({ body = {}, options = null }) =>
	axios.post("/appointment/physician/schedule", body, options);
export const patchPhysicianAppointment = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/appointment/physician/update/${params?.appointment_id}`, body, options);
export const getPatientAppointments = ({ query = {}, options = null }) =>
	axios.get(`/appointment/patient?${qs.stringify(query)}`, options);
export const getSinglePatientAppointment = ({ params = {}, options = null }) =>
	axios.get(`/appointment/patient/${params?.id}`, options);
export const getPatientAppointmentChildOrders = ({ params = {}, options = null }) =>
	axios.get(`/appointment/patient/${params?.id}/child-orders`, options);
export const postSinglePatientAppointment = ({ body = {}, options }) =>
	axios.post("/appointment/patient", body, options);
export const putSinglePatientAppointment = ({ params = {}, body = {}, options = null }) =>
	axios.put(`/appointment/patient/${params?.id}`, body, options);
export const getSinglePhysicianAppointment = ({ params = {}, options = null }) =>
	axios.get(`/appointment/physician/${params?.id}`, options);
export const deleteSinglePhysicianAppointment = ({ params = {}, body = {}, options = null }) =>
	axios.delete(`/appointment/physician/delete/${params?.id}`, { ...options, data: body });
export const deleteSinglePatientAppointment = ({ params = {}, body = {}, options = null }) =>
	axios.delete(`/appointment/patient/${params?.id}`, { ...options, data: body });
export const getPatientSegmentCategories = ({ query = {}, options = null }) =>
	axios.get(`/appointment/patient/segment-categories?${qs.stringify(query)}`, options);
export const postPatientAppointmentRemark = ({ params = {}, body = {}, options = null }) =>
	axios.post(`/appointment/patient/${params?.id}/remark`, body, options);
export const postPatientAppointmentRemarkReply = ({ params = {}, body = {}, options = null }) =>
	axios.post(`/appointment/patient/${params?.id}/remark/${params?.remark_id}/reply`, body, options);
